import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BYPASS_ERROR } from 'app/auth/helpers/error.interceptor';
import { EntityKpiDenominatorBulkRequestDto } from 'app/@types/dto/entity-kpi-denominator-bulk-request-dto.model';
import { EntityKpiDenominatorDto } from 'app/@types/dto/entity-kpi-denominator-dto.model';
import { OrganizationKpiDenominatorTypeDto } from 'app/@types/dto/organization-kpi-denominator-type-dto.model';

import { UrlService } from './url.service';

@Injectable({
    providedIn: 'root',
})
export class KpiDenominatorHttpService {
    constructor(
        private readonly http: HttpClient,
        private readonly urlService: UrlService,
    ) {}

    // Reads ride the global ErrorInterceptor: the backend returns 200 + empty lists for
    // "no data yet", so the interceptor only fires on real failures. Writes BYPASS_ERROR
    // because the KPI state surfaces their errors itself through completion Subjects
    // (the modal/settings form toast on failure).

    getTypes(orgId: string): Observable<OrganizationKpiDenominatorTypeDto[]> {
        return this.http.get<OrganizationKpiDenominatorTypeDto[]>(this.urlService.getKpiDenominatorTypes(orgId));
    }

    createType(orgId: string, type: OrganizationKpiDenominatorTypeDto): Observable<OrganizationKpiDenominatorTypeDto> {
        return this.http.post<OrganizationKpiDenominatorTypeDto>(this.urlService.getKpiDenominatorTypes(orgId), type, {
            context: new HttpContext().set(BYPASS_ERROR, true),
        });
    }

    updateType(
        orgId: string,
        typeId: string,
        type: OrganizationKpiDenominatorTypeDto,
    ): Observable<OrganizationKpiDenominatorTypeDto> {
        return this.http.put<OrganizationKpiDenominatorTypeDto>(
            this.urlService.getKpiDenominatorType(orgId, typeId),
            type,
            { context: new HttpContext().set(BYPASS_ERROR, true) },
        );
    }

    deleteType(orgId: string, typeId: string): Observable<void> {
        return this.http.delete<void>(this.urlService.getKpiDenominatorType(orgId, typeId), {
            context: new HttpContext().set(BYPASS_ERROR, true),
        });
    }

    getDenominators(orgId: string, years: number[]): Observable<EntityKpiDenominatorDto[]> {
        return this.http.get<EntityKpiDenominatorDto[]>(this.urlService.getKpiDenominators(orgId, years));
    }

    upsertDenominators(orgId: string, request: EntityKpiDenominatorBulkRequestDto): Observable<void> {
        return this.http.put<void>(this.urlService.getKpiDenominators(orgId), request, {
            context: new HttpContext().set(BYPASS_ERROR, true),
        });
    }
}
